import api from '~/services/api';

const baseURL = CONFIG.djangoBaseUrl;
const deleteBaseURL = CONFIG.armorUrl;

function uploadCSV(file: string | Blob) {
  const formData = new FormData();
  formData.append('file', file);

  return api.request({
    baseURL,
    url: 'user/orders/import/csv/v2/ajaxpreload/',
    method: 'POST',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data: formData,
  });
}

function getTemplates() {
  return api.request({
    baseURL,
    url: 'user/orders/import/csv/v2/mapping/',
    method: 'GET',
  });
}

function saveTemplate(payload) {
  return api.request({
    baseURL,
    url: 'user/orders/import/csv/v2/mapping/',
    method: 'POST',
    data: payload,
  });
}

function deleteTemplate(payload) {
  return api.request({
    baseURL: deleteBaseURL,
    url: 'user/orders/import/csv/v2/mapping/',
    method: 'DELETE',
    data: payload,
  });
}

function importCSVOrders(payload) {
  return api.request({
    baseURL,
    url: 'user/orders/import/csv/v2/',
    method: 'POST',
    data: payload,
  });
}

export { uploadCSV, getTemplates, saveTemplate, importCSVOrders, deleteTemplate };
